var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path20, _path21, _rect43, _path22, _path23, _circle, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _polygon, _path36, _path37, _path38, _path39, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _rect44, _rect45, _rect46, _rect47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1104.51,
    height: 798.9,
    viewBox: "0 0 1104.51 798.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d64dd008-0b7c-476d-9152-2ee1019c24ab-199",
    x1: 778.88,
    y1: 597.01,
    x2: 778.88,
    y2: 287.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b18575fc-07c4-4a11-b143-4649daeb988c-200",
    x1: 514.35,
    y1: 472.3,
    x2: 514.35,
    y2: 454.49,
    xlinkHref: "#d64dd008-0b7c-476d-9152-2ee1019c24ab-199"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grand_slam") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1151.86,119.74c-3.72,31.61-29.81,56.64-36,87.86a85.19,85.19,0,0,0-1.46,12.41c-.89,17.93,2.66,36.23.83,54.19-3.41,33.68-23.88,60-49.87,82.81-19.66,17.21-42.48,32.35-63.47,47-53.44,37.33-103.56,84.46-125.51,145.84-14.63,40.93-15.75,85.41-26.49,127.53s-35.2,85.22-76.54,98.65c-44.37,14.42-93.26-9.62-138.92-.12-49,10.2-83.75,56.51-132.1,69.59-61.43,16.62-122.65-24.22-185.71-32.73-30.28-4.09-61.1-.62-91.54-3.24a230.08,230.08,0,0,1-96-30.51c-10-5.87-20.11-13.08-24.76-23.74-4-9.21-3.39-19.71-2.16-29.68,4.6-37,16.24-77.22-2.07-109.74-16.89-30-57.82-51.46-51.75-85.33C52,510.15,72,497.42,90.62,488.29c38.32-18.83,79.14-33.57,113.39-59,24.5-18.22,45.6-43.64,54.6-72.23a96.31,96.31,0,0,0,4.45-35.42c-1.26-18.9-7.8-40.12,3.6-55.25,4.94-6.56,12.51-10.59,20.12-13.67,28.7-11.6,60.58-12.27,90.42-20.51A124.73,124.73,0,0,0,406.45,220c18.2-10.54,32.85-26.07,36.39-46.34,2.07-11.88.23-24.85,6.16-35.35,10-17.8,29.77-25.24,51.85-27.66,27.33-3,58.28,1.69,79,4l2.07.22c26.61,2.77,53-3.12,78.93-12,28-9.51,55.37-22.45,82-31.65q3.75-1.3,7.48-2.49a383,383,0,0,1,59.52-13.85,389.12,389.12,0,0,1,86-3.32,381.53,381.53,0,0,1,43.38,5.64q6.32,1.2,12.62,2.57c24.42,5.23,48.71,11.62,73.62,12,1.79,0,3.59,0,5.38,0,29.71-.51,60.09-8.06,88.28,1.06C1132,77,1144.24,85.2,1149.4,97.64,1152.27,104.57,1152.73,112.3,1151.86,119.74Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.44,220h-25.67a34,34,0,0,0-22.34-30,24,24,0,1,0-23.15,0,34,34,0,0,0-22.34,30h-.22a34,34,0,0,0-22.28-29,24,24,0,1,0-35.17-25.41,33.93,33.93,0,0,0-9.83-5.59,24,24,0,1,0-23.15,0,34,34,0,0,0-22.42,32v28h-11V198a34,34,0,0,0-22.42-32,24,24,0,1,0-23.15,0,34.1,34.1,0,0,0-19.6,18.44A34.09,34.09,0,0,0,815.43,172a24,24,0,1,0-23.15,0,34.11,34.11,0,0,0-17.42,14.23V182a34,34,0,0,0-22.42-32,24,24,0,1,0-23.15,0,34,34,0,0,0-22.42,32v38h-12a34.09,34.09,0,0,0-19.39-18,24,24,0,1,0-23.15,0,33.87,33.87,0,0,0-6.76,3.35A34,34,0,0,0,623.43,178a24,24,0,1,0-23.15,0,34.07,34.07,0,0,0-21,22.4,34,34,0,0,0-13.82-9.4,24,24,0,1,0-23.15,0,33.93,33.93,0,0,0-10.08,5.8A34.1,34.1,0,0,0,512.43,178a24,24,0,1,0-23.15,0,34,34,0,0,0-22.42,32v10h-60.4a124.73,124.73,0,0,1-29.25,12.15c-29.84,8.24-61.72,8.91-90.42,20.51-7.61,3.08-15.18,7.11-20.12,13.67-11.4,15.13-4.86,36.35-3.6,55.25A96.31,96.31,0,0,1,258.61,357H1065.4c26-22.76,46.46-49.13,49.87-82.81C1117.1,256.24,1113.55,237.94,1114.44,220Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M820,569.07s.35,12.65-10.9,15.11,4.57,9.84,10.9,8.08,32.34-24.6,32.34-24.6-9.14-14.06-15.11-14.06C837.19,553.61,826.3,571.88,820,569.07Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M769,561.69s.7,11.6-16.52,18.28c0,0-17.93,1.76-5.62,10.54s49.56-2.46,49.56-2.46-.7-11.25-4.92-20.39C791.5,567.67,771.12,566.26,769,561.69Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M903.39,318.88c-5.43-6.41-17,17.46-17,17.46L844.26,346a14.09,14.09,0,0,1-6.86-4.66,19.46,19.46,0,0,0,17.57-9.7l-10.86-.61a8.85,8.85,0,0,1-3.22-.58c-2.08-.95-3-3.26-4.12-5.25A25.42,25.42,0,0,0,823,313.5c-3.89-1.38-8.23-1.86-11.57-4.26-2.41-1.73-4.05-4.28-6-6.51-9.25-10.68-24.57-13.64-38.71-15.48-2.5-.33-5.35-.54-7.23,1.12-1.29,1.13-1.8,2.9-2.92,4.2-1.91,2.23-5.14,2.68-8.05,3.23a26.33,26.33,0,0,0-10.28,3.91,13,13,0,0,0-5.73,9c-.56,5.55,3.49,10.86,2.74,16.39-.23,1.7-.91,3.32-1,5a15.7,15.7,0,0,0,.76,4.76c1.22,4.69,2.16,9.57,1.33,14.34s-3.75,9.42-8.32,11.19A25.17,25.17,0,0,0,745.33,358c5.14-2.94,8.92-8.37,9.1-14.22,0-.14,0-.28,0-.42l.61.24c.09.33.18.68.26,1.05l.91.26a19.35,19.35,0,0,1,0,6.31l-6.33,5.06s0,.37.08,1l-.08.06s0,.3.07.83l-12.38,7.72a49.47,49.47,0,0,0-17,24.23L709.34,407.6s-7.24,6.77-11.22,7.84l-33.67,29.22s-11.66,6.35-11.61,12.69h0q0,.19,0,.39v0q0,.19,0,.38v0q0,.18.08.36v0c0,.12.07.23.11.35l0,.06c0,.11.08.22.13.33l0,.07.16.32,0,.08.18.3.06.09.2.29.08.1.23.28.1.11.25.26.12.12.27.25.14.13.3.25.16.13.33.24.17.13.38.26.16.11.6.36c13,7.48,16.29-11.76,16.29-11.76l39.1-25.66s32.22-29.22,32.22-35.63l7,3-.12,1.26s0,.28,0,.77l0,.3s-.36,15,18.46,18.89c0,0,17.21,17.27,17.73,22.76,0,.11,0,.21,0,.32s0,.05,0,.08c-.3,4.2,3.75,12.43,5,14.94l-6.85,5.73.07,1-.07.06.26,3.56c-7.75,8.35-19,20.74-20.17,23.52-1.81,4.28-1.81,13.54,2.53,23.16l4.71,42.4v12.35l-2.17-1v2.8a5.18,5.18,0,0,1-2.53-2.09s0,.13,0,.36h0v0c-.06,2.07-1.17,12.1-17,18.15,0,0-10.5,1-10.23,5.34-.11,1.46,1.05,3.33,4.43,5.71,12.67,8.91,51-2.49,51-2.49s0-.12,0-.35h0s-.72-11.4-5.07-20.67c0,0-1-.07-2.53-.22v-2.63l-1.58-.27A69.39,69.39,0,0,1,789,551.92a116.31,116.31,0,0,0,2.07-34.5,43.58,43.58,0,0,0,6,6.17l22.85,36.24,2.7,5.55c-1,.72-2,1.35-2.82,1.86l4.59,4.25a4.28,4.28,0,0,1-3.2,0s.36,12.83-11.22,15.32c-4.62,1-4.8,2.78-2.95,4.46,2.46,2.67,10.43,5.21,14.53,4.09,6.52-1.78,33.31-24.94,33.31-24.94a69,69,0,0,0-8.05-9.85c-2.62-2.62-5.49-4.75-7.88-4.75,0,0-.55.91-1.48,2.3l-2.86-2.65-.29.27c-.24-.79-.46-1.59-.65-2.38,0,0-5.55-25.43-22.55-44.69,0,0-3.35-2.77,1.83-11.92,0,0,8.38-9.94,15.69-20.72,10.63,2.07,21.57,1.22,29.87-6.44l-.11-.66.47-.41-3.62-22.45s1.63-21.2-24.8-38.31c0,0-14.3-17.64-19.37-40.09l-.29,0,.29-3.89c3.26,2.49,38-2.14,38-2.14l46-19.24c2.61-1.43,9.88-11.34,9.85-18.52A7.19,7.19,0,0,0,903.39,318.88Z",
    transform: "translate(-47.74 -50.55)",
    fill: "url(#d64dd008-0b7c-476d-9152-2ee1019c24ab-199)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M835.69,342.07a13.67,13.67,0,0,0,9.86,5.19,31.65,31.65,0,0,1-10.11,6.32c-10.82,4.25-23.92,3-33.24-4.08-2.19-1.67-4.29-3.66-7-4.31-2.32-.57-4.76,0-7.16-.13a14.21,14.21,0,0,1-12.92-10.62c-.69-2.93-.41-6-.91-9a14,14,0,0,0-.33-1.51c-1.4-5-7.94-10.38-13.45-8.92-5.2,1.37-7.87,9.55-7.76,14.23.11,5.15,2.6,10.07,2.44,15.22-.18,5.77-3.85,11.13-8.84,14a24.1,24.1,0,0,1-16.77,2.34c4.44-1.75,7.27-6.34,8.08-11s-.11-9.52-1.29-14.14a15.72,15.72,0,0,1-.74-4.7c.09-1.69.75-3.29,1-5,.73-5.45-3.2-10.69-2.66-16.16a12.79,12.79,0,0,1,5.56-8.85,25.32,25.32,0,0,1,10-3.86c2.82-.54,6-1,7.82-3.19,1.09-1.28,1.58-3,2.83-4.15,1.82-1.63,4.59-1.42,7-1.1,13.73,1.82,28.59,4.73,37.58,15.27,1.88,2.2,3.47,4.72,5.81,6.42,3.24,2.37,7.45,2.84,11.23,4.2a24.79,24.79,0,0,1,13.35,11.57c1,2,2,4.24,4,5.18a8.47,8.47,0,0,0,3.13.58l10.54.6A18.83,18.83,0,0,1,835.69,342.07Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f55f44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M782.54,342.2s5.1.53,15.29-1.93,20.39,5.27,20.39,5.27l21.44,1.76,43.58-10.19s11.25-23.55,16.52-17.22-4.92,21.09-8.08,22.85L847,361.7s-33.74,4.57-36.9,2.11l-.7,9.49-16.87-8.08L785.18,348Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M891.67,342.37l-44.64,19s-33.74,4.57-36.9,2.11l-.7,9.49-16.87-8.08-7.38-17.22-2.31-5.07-.33,0,2.64,5.8,7.38,17.22,16.87,8.08.7-9.49c3.16,2.46,36.9-2.11,36.9-2.11l44.64-19c2.58-1.43,9.81-11.49,9.56-18.59C901,331.53,894.17,341,891.67,342.37Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M753.19,357.13l-14.41,9.14a48.71,48.71,0,0,0-16.52,23.9l-10.9,17.22s-7,6.68-10.9,7.73l-32.69,28.82s-19.68,10.9-7,18.28,15.82-11.6,15.82-11.6l38-25.31s31.28-28.82,31.28-35.15l11.25,4.92Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M745.81,389.47c0,6.33-31.28,35.15-31.28,35.15l-38,25.31s-3.16,19-15.82,11.6c-2.9-1.69-4.1-3.57-4.23-5.45-.14,2.12,1,4.25,4.23,6.16,12.65,7.38,15.82-11.6,15.82-11.6l38-25.31s31.28-28.82,31.28-35.15l11.25,4.92-.07-.74Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M795.2,462.83s-11,34.87-10.73,39.43,4.18,12.8,12.09,19.54l22.19,35.75,6.83,14.26,13.43-3.7s-5-8.89-6.94-16.94c0,0-5.39-25.09-21.89-44.08,0,0-3.25-2.73,1.77-11.76,0,0,24.72-29.76,25.55-41.85Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M795.2,462.83s-11,34.87-10.73,39.43,4.18,12.8,12.09,19.54l22.19,35.75,6.83,14.26,13.43-3.7s-5-8.89-6.94-16.94c0,0-5.39-25.09-21.89-44.08,0,0-3.25-2.73,1.77-11.76,0,0,24.72-29.76,25.55-41.85Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M793.61,454.14s-25,26.71-26.71,30.93-1.76,13.36,2.46,22.85l4.57,41.83v15.82L787.64,568s-.7-10.19,1.05-18.28c0,0,6-25-.7-49.21,0,0-1.76-3.87,6.68-9.84,0,0,35.15-16.17,41.12-26.71Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M793.26,454.14s-25,26.71-26.71,30.93-1.76,13.36,2.46,22.85l4.57,41.83v15.82L787.29,568s-.7-10.19,1.05-18.28c0,0,6-25-.7-49.21,0,0-1.76-3.87,6.68-9.84,0,0,35.15-16.17,41.12-26.71Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M793.44,454.14l-.19.2L834.56,464c-6,10.54-41.12,26.71-41.12,26.71-8.44,6-6.68,9.84-6.68,9.84,6.68,24.25.7,49.21.7,49.21-1.62,7.45-1.15,16.67-1.07,18.09l1.07.19s-.7-10.19,1.05-18.28c0,0,6-25-.7-49.21,0,0-1.76-3.87,6.68-9.84,0,0,35.15-16.17,41.12-26.71Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M755,339.91s4.92,7.73,0,17.93l4.92,25.31,20.39-2.81,9.84-11.25L782.37,342s-6.33,2.46-7-14.76Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M750.73,357.84s1.41,18.63,3.16,22.85l-1.41,14.76s-.35,14.76,17.93,18.63c0,0,17.57,17.93,17.22,22.85s5.27,15.46,5.27,15.46l-7,6,.35,4.92,4.92-4.92s42.53,31.28,65,10.19l-3.51-22.14s3-18.8-22.67-35.67c0,0-15.29-19.51-20.21-41.65,0,0-14.06-1.41-17.57-6.68l-7-21.09-5.8,1.23,5.45,23.37s-6.33,21.09-23.9,12l-4-25Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M750.73,356.78s1.41,18.63,3.16,22.85l-1.41,14.76s-.35,14.76,17.93,18.63c0,0,17.57,17.93,17.22,22.85s5.27,15.46,5.27,15.46l-7,6,.35,4.92,4.92-4.92s42.53,31.28,65,10.19l-3.51-22.14s1.58-20.91-24.08-37.78c0,0-13.88-17.4-18.8-39.54,0,0-14.06-1.41-17.57-6.68l-7-21.09-5.8,1.23,5.45,23.37s-6.33,21.09-23.9,12l-4-25Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#252a62"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M566.48,440.67",
    transform: "translate(-47.74 -50.55)",
    fill: "#b4abab"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 516.33,
    y: 394.63,
    width: 56.33,
    height: 0.35,
    fill: "#b4abab"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 392.17,
    width: 53.52,
    height: 0.35,
    fill: "#b4abab"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 518.79,
    y: 389.71,
    width: 48.95,
    height: 0.35,
    fill: "#b4abab"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 520.55,
    y: 387.25,
    width: 43.32,
    height: 0.35,
    fill: "#b4abab"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 523.01,
    y: 384.79,
    width: 37,
    height: 0.35,
    fill: "#b4abab"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 526.17,
    y: 382.33,
    width: 29.62,
    height: 0.35,
    fill: "#b4abab"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 531.09,
    y: 379.87,
    width: 18.37,
    height: 0.35,
    fill: "#b4abab"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 515.27,
    y: 397.44,
    width: 59.49,
    height: 0.35,
    fill: "#b4abab"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 515.27,
    y: 400.25,
    width: 60.55,
    height: 0.35,
    fill: "#b4abab"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 514.22,
    y: 403.06,
    width: 62.3,
    height: 0.35,
    fill: "#b4abab"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 514.22,
    y: 405.87,
    width: 63.12,
    height: 0.35,
    fill: "#b4abab"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 514.22,
    y: 408.69,
    width: 62.77,
    height: 0.35,
    fill: "#b4abab"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 514.92,
    y: 411.5,
    width: 61.01,
    height: 0.35,
    fill: "#b4abab"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 516.33,
    y: 414.31,
    width: 57.84,
    height: 0.35,
    fill: "#b4abab"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 516.33,
    y: 417.12,
    width: 55.38,
    height: 0.35,
    fill: "#b4abab"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 518.79,
    y: 419.93,
    width: 49.76,
    height: 0.35,
    fill: "#b4abab"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 521.25,
    y: 422.74,
    width: 43.43,
    height: 0.35,
    fill: "#b4abab"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 524.06,
    y: 425.56,
    width: 36.41,
    height: 0.35,
    fill: "#b4abab"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 529.69,
    y: 428.37,
    width: 25.86,
    height: 0.35,
    fill: "#b4abab"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 521.57,
    y: 386.25,
    width: 0.35,
    height: 37.29,
    fill: "#b4abab"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 519.46,
    y: 389.06,
    width: 0.35,
    height: 32.02,
    fill: "#b4abab"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 517.35,
    y: 392.22,
    width: 0.35,
    height: 26.05,
    fill: "#b4abab"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 515.24,
    y: 397.14,
    width: 0.35,
    height: 16.56,
    fill: "#b4abab"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 524.38,
    y: 383.79,
    width: 0.35,
    height: 42.21,
    fill: "#b4abab"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 527.19,
    y: 382.03,
    width: 0.35,
    height: 45.38,
    fill: "#b4abab"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 380.62,
    width: 0.35,
    height: 47.84,
    fill: "#b4abab"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 532.82,
    y: 379.57,
    width: 0.35,
    height: 49.95,
    fill: "#b4abab"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 535.63,
    y: 378.52,
    width: 0.35,
    height: 52.06,
    fill: "#b4abab"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 538.44,
    y: 378.52,
    width: 0.35,
    height: 52.06,
    fill: "#b4abab"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 541.25,
    y: 378.52,
    width: 0.35,
    height: 52.06,
    fill: "#b4abab"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 544.06,
    y: 378.52,
    width: 0.35,
    height: 52.06,
    fill: "#b4abab"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 546.88,
    y: 379.57,
    width: 0.35,
    height: 51,
    fill: "#b4abab"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 549.69,
    y: 380.27,
    width: 0.35,
    height: 49.95,
    fill: "#b4abab"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 552.5,
    y: 380.98,
    width: 0.35,
    height: 48.54,
    fill: "#b4abab"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 555.31,
    y: 382.38,
    width: 0.35,
    height: 45.73,
    fill: "#b4abab"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 558.12,
    y: 383.79,
    width: 0.35,
    height: 43.27,
    fill: "#b4abab"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 560.93,
    y: 386.25,
    width: 0.35,
    height: 39.4,
    fill: "#b4abab"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 563.75,
    y: 387.3,
    width: 0.35,
    height: 36.24,
    fill: "#b4abab"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 566.56,
    y: 389.41,
    width: 0.35,
    height: 32.37,
    fill: "#b4abab"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 569.37,
    y: 391.87,
    width: 0.35,
    height: 27.8,
    fill: "#b4abab"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 572.18,
    y: 393.98,
    width: 0.35,
    height: 22.53,
    fill: "#b4abab"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 574.99,
    y: 398.55,
    width: 0.35,
    height: 14.8,
    fill: "#b4abab"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M589.64,482.18a33,33,0,0,1-9.26-1.27c-7.46-2.17-13.09-6.61-16.28-12.85a27.37,27.37,0,0,1-2-18.7c2.82-12,13.69-23.55,30.9-20.46l.58.11a42.88,42.88,0,0,1,16.71,7.14c28.56,20.1,35,17.41,35,17.38l1.06-.61v4.46l-.77-.08c-9.38-1-24,9.74-31.94,16.2a37.69,37.69,0,0,1-20.86,8.55Q591.18,482.18,589.64,482.18Zm-2.15-52.38c-13.28,0-21.68,9.76-24.05,19.88-2.62,11.19,1.68,25.32,17.33,29.87a32.92,32.92,0,0,0,11.88,1.09,36.3,36.3,0,0,0,20.08-8.24c7.86-6.43,22.33-17,32.2-16.56V455c-2.77.32-11.56-.9-35.48-17.74a41.48,41.48,0,0,0-16.17-6.91l-.57-.11A29.62,29.62,0,0,0,587.49,429.81Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#535461"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M595.79,401.13H626a3.51,3.51,0,0,1,3.51,3.51v0a3.51,3.51,0,0,1-3.51,3.51H595.79a0,0,0,0,1,0,0v-7A0,0,0,0,1,595.79,401.13Z",
    fill: "#535461"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 595.79,
    y: 401.13,
    width: 4.22,
    height: 7.03,
    fill: "#f0e4e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M616,471.58l-.82-1.14c6-4.31,9-9,9-14,0-8.53-8.92-15.16-9-15.22l.83-1.14c.39.29,9.61,7.1,9.59,16.36C625.6,461.91,622.38,467,616,471.58Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#535461"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M776.8,339.5c-1.05-2.18-1.93-5.75-2.16-11.54l-20.39,12.65a15.72,15.72,0,0,1,1.75,4.7,19.68,19.68,0,0,0,20.8-5.81Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 714.94,
    cy: 275.3,
    r: 19.68,
    fill: "#fdb797"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M761.75,321c2,.8,3.33,2.68,5.23,3.65,2.73,1.39,6,.67,9.06,1.24,3.43.65,6.57,3,10,2.68,4.12-.36,7.13-4.68,7-8.81s-2.85-7.83-6.21-10.23-7.36-3.72-11.29-5c-5-1.65-10.4-3.31-15.57-2.12-4.82,1.11-17.8,7.49-17.13,13.53C743.93,325.65,756.73,319,761.75,321Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M761.75,320.31c2,.8,3.33,2.68,5.23,3.65,2.73,1.39,6,.67,9.06,1.24,3.43.65,6.57,3,10,2.68,4.12-.36,7.13-4.68,7-8.81s-2.85-7.83-6.21-10.23-7.36-3.72-11.29-5c-5-1.65-10.4-3.31-15.57-2.12-4.82,1.11-17.8,7.49-17.13,13.53C743.93,324.95,756.73,318.29,761.75,320.31Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f55f44"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M791,437.09s1.05,8.79,3.87,11.6",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M826.83,408.62a11.51,11.51,0,0,1-1.76,7.73",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M810,386.13s-3.16,6.33-11.6,10.54",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.82,377.87c6.15,3.2,10.92,2.69,14.53.69-3.24,1-7.22.78-12.07-1.74l-4-25-2.33,1.89Z",
    transform: "translate(-47.74 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.07,341.32l7,21.09c3.51,5.27,17.57,6.68,17.57,6.68,4.92,22.14,18.8,39.54,18.8,39.54,25.66,16.87,24.08,37.78,24.08,37.78l3.51,22.14a26,26,0,0,1-6.37,4.4,25.92,25.92,0,0,0,8.83-5.46L853,445.35s1.58-20.91-24.08-37.78c0,0-13.88-17.4-18.8-39.54,0,0-14.06-1.41-17.57-6.68l-7-21.09-5.8,1.23.12.51Z",
    transform: "translate(-47.74 -50.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789,458.36l-2.55,2.55.09,1.31,3.28-3.28Z",
    transform: "translate(-47.74 -50.55)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M803.63,447.29s14.76-10.19,26.71-10.19",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M773.4,410.38s8.44-5.27,10.9-9.49",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M666.55,448s-4.22,5.27-2.11,7,7.38-6,7.38-6Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#fdb797"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M514.35,454.49a8.91,8.91,0,0,0-8.91,8.91,8,8,0,0,0,0,.88q0,.24.06.48l0,.13v0a8.83,8.83,0,0,0,3,5.27l.29.24a8.91,8.91,0,1,0,5.48-15.92Z",
    transform: "translate(-47.74 -50.55)",
    fill: "url(#b18575fc-07c4-4a11-b143-4649daeb988c-200)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M509.24,469.94a8.31,8.31,0,1,0-3.2-6.54,7.42,7.42,0,0,0,0,.82q0,.22.05.45l0,.12v0a8.25,8.25,0,0,0,2.81,4.92Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#3ad29f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M509.24,469.94l.29,0c.11-1.16,3.34-3,6-4.49,2.79-1.59,4.52-2.61,4.8-3.47.37-1.1-.73-2.39-1.91-3.11-1.4-.87-3.4-1.28-4.82.14a43.68,43.68,0,0,1-7.47,5.18l.05.45,0,.12v0l0,0c.22-.12,5.41-3,7.79-5.4,1.18-1.17,2.89-.8,4.09,0s1.87,1.77,1.66,2.42-2.52,2-4.54,3.14c-2.87,1.65-5.84,3.33-6.21,4.76Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f0e4e4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M833,553.26s-9,8.44-14.35,11.6l4.86,4.57L839,567.31v-8.44Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f0e4e4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "726.89 511.85 723.73 510.44 723.73 519.58 741.3 522.39 741.3 514.31 726.89 511.85",
    fill: "#f0e4e4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M769,561s.7,11.6-16.52,18.28c0,0-17.93,1.76-5.62,10.54s49.56-2.46,49.56-2.46-.7-11.25-4.92-20.39C791.5,567,771.12,565.61,769,561Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M769,562s.7,11.6-16.52,18.28c0,0-17.93,1.76-5.62,10.54s49.56-2.46,49.56-2.46-.7-11.25-4.92-20.39C791.5,568,771.12,566.61,769,562Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f0e4e4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M820.32,568.42s.35,12.65-10.9,15.11,4.57,9.84,10.9,8.08S852.66,567,852.66,567,843.52,553,837.55,553C837.55,553,826.65,571.24,820.32,568.42Z",
    transform: "translate(-47.74 -50.55)",
    opacity: 0.05
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M820.32,569.42s.35,12.65-10.9,15.11,4.57,9.84,10.9,8.08S852.66,568,852.66,568,843.52,554,837.55,554C837.55,554,826.65,572.24,820.32,569.42Z",
    transform: "translate(-47.74 -50.55)",
    fill: "#f0e4e4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.11 453.46 306.09 554.97 356.08 656.47 256.11 656.47 156.14 656.47 206.12 554.97 256.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.11 453.46 148.09 554.97 198.08 656.47 98.11 656.47 98.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.11 453.46 237.09 554.97 287.08 656.47 187.11 656.47 107.11 649.47 112.63 604.71 137.12 554.97 187.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.11 453.46 354.09 554.97 404.08 656.47 304.11 656.47 204.14 656.47 254.12 554.97 304.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.11 453.46 447.09 554.97 497.08 656.47 397.11 656.47 297.14 656.47 347.12 554.97 397.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "497.11 453.46 547.09 554.97 597.08 656.47 497.11 656.47 397.14 656.47 447.12 554.97 497.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "597.11 453.46 647.09 554.97 697.08 656.47 597.11 656.47 497.14 656.47 547.12 554.97 597.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "699.11 453.46 749.09 554.97 799.08 656.47 699.11 656.47 599.14 656.47 649.12 554.97 699.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "800.11 453.46 850.09 554.97 900.08 656.47 800.11 656.47 700.14 656.47 750.12 554.97 800.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "894.11 453.46 944.09 554.97 994.08 656.47 894.11 656.47 794.14 656.47 844.12 554.97 894.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "1034.78 656.47 979.14 656.47 1029.12 554.97 1031.11 550.94 1034.78 656.47",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "954.11 453.46 1004.09 554.97 1054.08 656.47 954.11 656.47 854.14 656.47 904.12 554.97 954.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "983.11 453.46 1033.09 554.97 1044.11 577.33 1044.11 656.47 983.11 656.47 883.14 656.47 933.12 554.97 983.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "1016.11 453.46 1016.11 656.47 916.14 656.47 966.12 554.97 1016.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "453.11 453.46 503.09 554.97 553.08 656.47 453.11 656.47 353.14 656.47 403.12 554.97 453.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "650.11 453.46 700.09 554.97 750.08 656.47 650.11 656.47 550.14 656.47 600.12 554.97 650.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "847.11 453.46 897.09 554.97 947.08 656.47 847.11 656.47 747.14 656.47 797.12 554.97 847.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "1044.11 453.46 1048.54 462.47 1042.11 555.47 1044.11 656.47 1044.11 656.47 944.14 656.47 994.12 554.97 1044.11 453.46",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "854.11 657.47 804.12 555.97 754.14 454.46 854.11 454.46 954.08 454.46 904.09 555.97 854.11 657.47",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "649.11 657.47 599.12 555.97 549.14 454.46 649.11 454.46 749.08 454.46 699.09 555.97 649.11 657.47",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "444.11 657.47 394.12 555.97 344.14 454.46 444.11 454.46 544.08 454.46 494.09 555.97 444.11 657.47",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.11 657.47 189.12 555.97 139.14 454.46 239.11 454.46 339.08 454.46 289.09 555.97 239.11 657.47",
    fill: "none",
    stroke: "#f0e4e4",
    strokeMiterlimit: 10
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 125.11,
    y: 444.47,
    width: 910,
    height: 18,
    fill: "#f0e4e4"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 125.11,
    y: 649.47,
    width: 910,
    height: 18,
    fill: "#f0e4e4"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 429.47,
    width: 36,
    height: 253,
    fill: "#535461"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1017.11,
    y: 429.47,
    width: 36,
    height: 253,
    fill: "#535461"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.af3b44c0c7e8b70342f4aeaec241b877.svg";
export { ForwardRef as ReactComponent };